'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('@slate-editor/utils');

var _BoldUtils = require('./BoldUtils');

var BoldKeyboardShortcut = function BoldKeyboardShortcut(event, change) {
  if (_utils.keyboardEvent.isMod(event) && event.key === 'b') return (0, _BoldUtils.boldMarkStrategy)(change);
  return;
};

exports.default = BoldKeyboardShortcut;